import React, { memo, forwardRef } from "react";
const SvgCapitalP = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.54 15.01h1.76c.413 0 .807-.027 1.18-.08a3.666 3.666 0 001-.32c.293-.16.527-.373.7-.64.173-.267.26-.613.26-1.04 0-.413-.087-.747-.26-1a1.752 1.752 0 00-.7-.62 2.719 2.719 0 00-.98-.28 7.64 7.64 0 00-1.12-.08h-1.84v4.06zm2.1-6.18c.813 0 1.547.073 2.2.22.653.147 1.213.387 1.68.72.467.333.827.76 1.08 1.28.253.52.38 1.147.38 1.88 0 .787-.147 1.447-.44 1.98a3.622 3.622 0 01-1.2 1.3c-.493.32-1.073.553-1.74.7a9.845 9.845 0 01-2.12.22h-1.94v4.62c0 .307-.047.553-.14.74a1.344 1.344 0 01-.34.42.814.814 0 01-.4.2c-.147.04-.273.06-.38.06-.107 0-.233-.02-.38-.06a.94.94 0 01-.42-.2 1.518 1.518 0 01-.32-.42c-.093-.187-.14-.433-.14-.74V10.33c0-1 .5-1.5 1.5-1.5h3.12z"
      />
    </svg>
  );
});
SvgCapitalP.displayName = "SvgCapitalP";
const MemoForwardRef = memo(SvgCapitalP);
export default MemoForwardRef;
